<template>
  <el-dialog
    id="subscriptionDialog"
    :visible.sync="showLocal"
    :width="dialogWidth"
  >
    <!-- eslint-disable vue/no-v-html -->
    <div
      class="description"
      v-html="$t('customAlert.subscription.availEngagementDescription')"
    ></div>
    <!-- eslint-enable vue/no-v-html -->

    <div
      class="title"
      :class="{redText: selectedLeader.length > maxInviteCt}"
    >
      <i18n path="customAlert.subscription.selectedLeaderCount">
        <template #selectedLeader>
          {{ selectedLeader.length }}
        </template>
      </i18n>
      /
      <i18n path="customAlert.subscription.availEngagementCount">
        <template #availEngagements>
          {{ maxInviteCt }}
        </template>
      </i18n>
    </div>

    <el-table
      ref="multipleTable"
      :data="inviteReset"
      style="width: 85%;"
      @selection-change="handleSelectionChange"
    >
      <!--<el-table-column
        type="selection"
        width="55"
      />-->
      <el-table-column
        width="55"
      >
        <template slot-scope="data">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('customAlert.subscription.deactivateDisabled')"
            placement="top"
            :disabled="data.row.status !== 'completed'"
          >
            <div>
              <el-checkbox
                :key="data.row.uuid"
                :value="selectedLeader.includes(data.row.uuid)"
                :disabled="data.row.status === 'completed'"
                @change="handleSelectionChange(data.row.uuid, $event)"
              />
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        property="full_name"
        label="Name"
        width="120"
      />
      <el-table-column
        property="email"
        label="Email"
      />
    </el-table>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        round
        @click="confirmLeader"
      >
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from '@/api';
import { mapState, mapActions, mapGetters } from 'vuex';
import dialog from '@/mixins/dialog';

export default {
  name: 'SubscriptionDialog',

  mixins: [
    dialog,
  ],

  data: () => ({
    selectedLeader: [],
  }),

  computed: {
    ...mapState({
      inviteResetNegative: (state) => state.coachAlerts.inviteResetNegative,
      inviteResetPositive: (state) => state.coachAlerts.inviteResetPositive,
      maxInviteCt: (state) => state.user.profile.max_invite_ct,
      currInviteCt: (state) => state.user.profile.curr_invite_ct,
    }),

    ...mapGetters('coachAlerts', {
      hasInviteResetPositive: 'hasInviteResetPositive',
      hasInviteResetNegative: 'hasInviteResetNegative',
    }),

    inviteReset() {
      if (this.inviteResetNegative && this.inviteResetNegative.length > 0) {
        return this.inviteResetNegative;
      }

      return this.inviteResetPositive;
    },

    availEngagements() {
      if (this.inviteResetNegative && this.inviteResetNegative.length > 0) {
        return this.maxInviteCt;
      }
      return this.maxInviteCt - this.currInviteCt;
    },
  },

  methods: {
    ...mapActions('coachAlerts', [
      'fetchCoachAlerts',
    ]),

    handleSelectionChange(val, option) {
      if (Array.isArray(val)) {
        this.selectedLeader = val.map((el) => el.uuid);
      } else if (option) {
        this.selectedLeader.push(val);
      } else {
        this.selectedLeader = this.selectedLeader.filter((el) => el !== val);
      }
    },

    async confirmLeader() {
      if (this.selectedLeader.length > this.maxInviteCt) {
        this.$alert(
          `You cannot have more than ${this.maxInviteCt} engagement(s)`,
          'Unable to save', {
            confirmButtonText: 'OK',
            type: 'warning',
          },
        );
      } else {
        try {
          // 2 requests: 1 to handle exception, 1 to handle on_going
          // put all leader to exceptions, then set on-Going the selected ones
          let data = {
            leader_uuid_list: this.selectedLeader,
            engagement_status: 'exception',
          };
          await api.bulkUpdateLeaderEngagement(data);

          data = {
            leader_uuid_list: this.selectedLeader,
            engagement_status: 'on_going',
          };
          await api.bulkUpdateLeaderEngagement(data);

          this.fetchCoachAlerts();
          this.$EventBus.$emit('subscriptionUpdated');
          this.showLocal = false;
        } catch (err) {
          console.log(err);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  text-align: right;
  margin-bottom: 15px;
}

.description {
  margin-bottom: 15px;
}

.redText {
  color: red;
}
</style>

<style lang="scss">
#subscriptionDialog {
  .el-table thead {
    color: black;
  }

  .el-dialog__footer {
    text-align: center;
  }
}
</style>
